import React, { useRef, useState } from "react";
import { Button } from "@mui/material";
import { HiddenInput } from "./styles";

const FileInput = ({ name, label, register, errors, setFile }) => {
  const hiddenInputRef = useRef();

  const { ref: registerRef, ...rest } = register(name, {
    required: label + " is required",
  });

  const [preview, setPreview] = useState();

  const handleUploadedFile = (event) => {
    const file = event.target.files[0];
    console.log(file);
    setPreview(file.name);
    errors[name] = null;
    setFile(file);
  };

  const onUpload = () => {
    hiddenInputRef.current.click();
  };

  const uploadButtonLabel = preview ? "Change " + label : "Upload " + label;

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {errors[name] ? (
          <p
            style={{
              color: "#d32f2f",
              padding: 0,
              margin: 0,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {errors[name]?.message}
          </p>
        ) : (
          <p
            style={{
              padding: 0,
              margin: 0,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {preview ?? "No Image Selected"}
          </p>
        )}
        <div style={{ flex: 1 }} />
        <HiddenInput
          type="file"
          name={name}
          {...rest}
          onChange={handleUploadedFile}
          ref={(e) => {
            registerRef(e);
            hiddenInputRef.current = e;
          }}
          error={errors[name] ? true : false}
          helperText={errors[name]?.message}
        />

        <Button variant="text" onClick={onUpload}>
          {uploadButtonLabel}
        </Button>
      </div>
    </div>
  );
};

export default FileInput;
